export const DEFAULT_LIST_RESPONSE = {
  items: [], count: 0, limit: 0, page: 0,
};
